/* ══════════════════════════════════════
   CONTACT US — Scroll Reveal + Confirmation
══════════════════════════════════════ */
(function () {
  'use strict';

  /* Scroll-reveal */
  var reveals = document.querySelectorAll('.jcc-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Auto-scroll to confirmation */
  var conf = document.getElementById('jccConfirmation');
  if (conf) {
    conf.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();
